import { userRouter } from '../../route'
import { history } from '../../redux/store'
import { useEffect, useReducer } from 'react'
import { GET_SUPPLIER_BRAND_PAGE } from '../../api/myBrand'
import { isResponseCodeSuccess } from '../../tools/util'

type ActionType = 'setLoading' | 'setData' | 'setSearchData' | 'changePages'

interface Action {
  type: ActionType
  payload: any
}

interface State {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
}

const initState: State = {
  dataSource: { data: [], total: 100, loading: true },
  searchdata: {},
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setData':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setSearchData':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setLoading':
      newstate.dataSource.loading = action.payload
      return newstate
    case 'changePages':
      newstate.pages = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

const setLoading = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

/**
 * 设置表格数据
 * @param param
 * @returns
 */
const setData = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}): Action => ({
  type: 'setData',
  payload: param,
})
// 搜索
const setSearchData = (param: any): Action => ({
  type: 'setSearchData',
  payload: param,
})
// 切换分页
const changePages = (param: { pageNo: number; pageSize?: number }): Action => ({
  type: 'changePages',
  payload: param,
})

export function useHook() {
  const supRoute = userRouter[1].url
  const [state, dispatch] = useReducer(reducer, initState)
  const { dataSource, pages } = state

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchData(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const handleTableRefresh = () => {
    getdata(state)
  }

  // 切换分页
  const handlePaginationChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      changePages({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 获取表格数据
  const getdata = async (state: State) => {
    dispatch(setLoading(true))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_SUPPLIER_BRAND_PAGE({
      schemeId: params.schemeId,
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      brandCode: params.brandCode,
      brandNameCn: params.brandNameCn,
      brandNameEn: params.brandNameEn,
      manageType: params.manageType,
      mpmState: params.mpmState,
      tabType: '2',
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setData({
          dataSource: { data: resdata, total: count, loading: false },
          pageNo: res.data.pageNo,
        }),
      )
      dispatch(setLoading(false))
    } else {
      dispatch(setLoading(false))
    }
  }

  // 新增品牌
  const onAddBrand = () => {
    const url = supRoute + '/addBrand'
    history.replace({
      pathname: url,
    })
  }

  const onJump = (val: any) => {
    const url = supRoute + '/editBrand'
    history.replace({
      pathname: url,
      state: {
        BtnState: ['Edit'],
        brandId: val.brandId,
      },
    })
  }

  useEffect(() => {
    getdata(state)
    // eslint-disable-next-line
  }, [])

  return {
    pages,
    dataSource,
    onAddBrand,
    handleSearchClick,
    handleTableRefresh,
    handlePaginationChange,
    onJump,
  }
}
import { userRouter } from '../../route'
import { history } from '../../redux/store'
import { useEffect, useReducer } from 'react'
import { GET_SUPPLIER_BRAND_PAGE } from '../../api/myBrand'
import { isResponseCodeSuccess } from '../../tools/util'

type ActionType = 'setLoading' | 'setData' | 'setSearchData' | 'changePages'

interface Action {
  type: ActionType
  payload: any
}

interface State {
  dataSource: { data: any[]; total: number; loading: boolean }
  searchdata: any
  pages: {
    pageNo: number
    pageSize: number
  }
}

const initState: State = {
  dataSource: { data: [], total: 100, loading: true },
  searchdata: {},
  pages: {
    pageNo: 1,
    pageSize: 25,
  },
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setData':
      newstate.dataSource = action.payload.dataSource
      newstate.pages.pageNo = action.payload.pageNo
      return newstate
    case 'setSearchData':
      // 搜索 重置 分页
      newstate.searchdata = action.payload
      newstate.pages.pageNo = 1
      return newstate
    case 'setLoading':
      newstate.dataSource.loading = action.payload
      return newstate
    case 'changePages':
      newstate.pages = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

const setLoading = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

/**
 * 设置表格数据
 * @param param
 * @returns
 */
const setData = (param: {
  dataSource: { data: any[]; total: number; loading: boolean }
  pageNo: number
}): Action => ({
  type: 'setData',
  payload: param,
})
// 搜索
const setSearchData = (param: any): Action => ({
  type: 'setSearchData',
  payload: param,
})
// 切换分页
const changePages = (param: { pageNo: number; pageSize?: number }): Action => ({
  type: 'changePages',
  payload: param,
})

export function useHook() {
  const supRoute = userRouter[1].url
  const [state, dispatch] = useReducer(reducer, initState)
  const { dataSource, pages } = state

  // 搜索
  const handleSearchClick = (params: any) => {
    dispatch(setSearchData(params))
    getdata({
      ...state,
      ...{
        searchdata: params,
      },
    })
  }

  // 刷新
  const handleTableRefresh = () => {
    getdata(state)
  }

  // 切换分页
  const handlePaginationChange = (pageNo: number, pageSize?: number) => {
    dispatch(
      changePages({
        pageNo: pageNo,
        pageSize: pageSize,
      }),
    )
    getdata({
      ...state,
      ...{
        pages: {
          pageNo: pageNo,
          pageSize: pageSize ? pageSize : 25,
        },
      },
    })
  }

  // 获取表格数据
  const getdata = async (state: State) => {
    dispatch(setLoading(true))
    const params = { ...state.pages, ...state.searchdata }
    const res = await GET_SUPPLIER_BRAND_PAGE({
      schemeId: params.schemeId,
      pageNo: params.pageNo,
      pageSize: params.pageSize,
      brandCode: params.brandCode,
      brandNameCn: params.brandNameCn,
      brandNameEn: params.brandNameEn,
      manageType: params.manageType,
      mpmState: params.mpmState,
      tabType: '2',
    })
    if (isResponseCodeSuccess(res.code)) {
      const resdata = res.data.content
      const count = res.data.totalCount
      dispatch(
        setData({
          dataSource: { data: resdata, total: count, loading: false },
          pageNo: res.data.pageNo,
        }),
      )
      dispatch(setLoading(false))
    } else {
      dispatch(setLoading(false))
    }
  }

  // 新增品牌
  const onAddBrand = () => {
    const url = supRoute + '/addBrand'
    history.replace({
      pathname: url,
    })
  }

  const onJump = (val: any) => {
    const url = supRoute + '/editBrand'
    history.replace({
      pathname: url,
      state: {
        BtnState: ['Edit'],
        brandId: val.brandId,
      },
    })
  }

  useEffect(() => {
    getdata(state)
    // eslint-disable-next-line
  }, [])

  return {
    pages,
    dataSource,
    onAddBrand,
    handleSearchClick,
    handleTableRefresh,
    handlePaginationChange,
    onJump,
  }
}
